import { KeyboardEvent } from "react";
import { AcccessTokenT } from "src/types/authTypes";

export function onKeyNumber(e: KeyboardEvent<HTMLInputElement>) {
  !e.key.match(/[0-9]|[۰۹۱۲۳۴۵۶۷۸]|Backspace|Delete/i) && e.preventDefault();
}

export function validateUserLogin() {
  const access = localStorage.getItem("access-token");
  const expire = Number(localStorage.getItem("expire-token") ?? "");
  return access && expire && expire > Date.now();
}

export const setTokenData = ({
  accessToken,
  tokenExpiration,
}: AcccessTokenT) => {
  localStorage.setItem("access-token", accessToken);
  localStorage.setItem("expire-token", tokenExpiration);
};
